module.exports = __webpack_public_path__ + "static/media/photo2.df51e86c.jpg";